import { render, staticRenderFns } from "./positionLost.vue?vue&type=template&id=222c371b&scoped=true&"
import script from "./positionLost.vue?vue&type=script&lang=ts&"
export * from "./positionLost.vue?vue&type=script&lang=ts&"
import style0 from "./positionLost.vue?vue&type=style&index=0&id=222c371b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c371b",
  null
  
)

export default component.exports